/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Application_Phase_SavedInputs */

const en_admin_application_phase_saved = /** @type {(inputs: Admin_Application_Phase_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registration phases saved.`)
};

const de_admin_application_phase_saved = /** @type {(inputs: Admin_Application_Phase_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldephasen gespeichert.`)
};

/**
* | output |
* | --- |
* | "Registration phases saved." |
*
* @param {Admin_Application_Phase_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_application_phase_saved = /** @type {((inputs?: Admin_Application_Phase_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Application_Phase_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_application_phase_saved(inputs)
	return en_admin_application_phase_saved(inputs)
});